import { BaseApi } from '@shared/config';
import {
  type Company,
  type UpdateCompanyParams,
  type GetCompanyTypesResponse,
  type GetCompaniesRequest,
  type CreateCompanyParams,
  type UpdateCompanyActivityParams,
  type UpdateCompanyActivityResponse,
  type VerifyCompanyNccParams,
  type VerifyCompanyNccResponse,
  type ConfirmCompanyNccResponse,
} from './types';

class CompanyApi extends BaseApi {
  getCompany = (id: string): Promise<Company> => {
    return this.instance.get(`companies/${id}`);
  };

  getCompanies = <T>(params: GetCompaniesRequest): Promise<T> => {
    return this.instance.get(`companies`, { params });
  };

  updateCompany = (
    id: string,
    params: UpdateCompanyParams
  ): Promise<Company> => {
    return this.instance.put(`companies/${id}`, params);
  };

  getCompanyTypes = (): Promise<GetCompanyTypesResponse> => {
    return this.instance.get('/companies/types');
  };

  createCompany = (params: CreateCompanyParams): Promise<Company> => {
    return this.instance.post('/companies', params);
  };

  updateCompanyActivity = (
    id: string,
    params: UpdateCompanyActivityParams
  ): Promise<UpdateCompanyActivityResponse> => {
    return this.instance.put(`companies/${id}/change-activity`, params);
  };

  verifyCompanyNcc = (
    params: VerifyCompanyNccParams
  ): Promise<VerifyCompanyNccResponse> => {
    return this.instance.post('companies/verify-ncc', params);
  };

  confirmCompanyNcc = (id: string): Promise<ConfirmCompanyNccResponse> => {
    return this.instance.post(`companies/${id}/confirm-ncc`);
  };

  exportCompanies = ({
    dateFrom,
    dateTo,
  }: {
    dateFrom: string | null;
    dateTo?: string | null;
  }) => {
    return this.instance.post(
      `companies/export`,
      {
        data: dateFrom &&
          dateTo && {
            dateFrom,
            dateTo,
          },
      },
      {
        responseType: 'blob',
      }
    );
  };
}

export const companyApi = new CompanyApi();
